export const destinationsForm = {
  table: "v_destinations",
  required: ["type", "destination", "context"],
  sections: {
    "Basic Info": [
      "destination_type",
      "destination_area_code",
      "destination_number",
      "destination_caller_id_name",
      "destination_caller_id_number",
      "destination_context",
      "destination_order",
      "destination_enabled",
      "destination_description",
    ],

    "Conditions": ["destination_conditions"],

    "Actions": [
      "destination_actions",
      "destination_cid_name_prefix",
      "destination_record",
      "destination_hold_music",
      "destination_distinctive_ring",
      "destination_ringback",
      "destination_account_code",
    ],

    "Assignments": ["user", "group"],

    "Usage": [
      "destination_type_voice",
      "destination_type_fax",
      "destination_type_text",
      "destination_type_emergency",
    ],

    "Domain Settings": ["domain"],
  },
  types: {
    destination_enabled: "boolean",
    destination_record: "boolean",
    destination_hold_music: "boolean",
    destination_distinctive_ring: "boolean",
    destination_type_voice: "boolean",
    destination_type_fax: "boolean",
    destination_type_text: "boolean",
    destination_type_emergency: "boolean",
  },
};

export const dialplanManagerForm = {
  table: "v_dialplans",
  required: ["name", "number", "context"],
  sections: {
    "Basic Info": [
      "dialplan_name",
      "dialplan_number",
      "hostname",
      "dialplan_context",
      "dialplan_continue",
      "dialplan_order",
      "dialplan_destination",
      "domain",
      "dialplan_enabled",
      "dialplan_description",
    ],
    "Actions & Conditions": [
      "tag",
      "type",
      "data",
      "break",
      "inline",
      "group",
      "order_action",
      "enabled_action",
      "delete_action",
    ],
    "Advanced Settings": ["priority", "timeout", "active"], 
  },
  types: {
    dialplan_enabled: "boolean",
    enabled_action: "boolean",
    delete_action: "boolean",
    active: "boolean",
  },
};


